import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { ReportContext } from '../context/ReportProvider';

interface UseFetchResult<T> {
    data: T | null;
    error: Error | null;
    loading: boolean;
}

function useFetch<T>(apiUrl: string): UseFetchResult<T> {
    const [data, setData] = useState<T | null>(null);
    const [error, setError] = useState<Error | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const reportContext = useContext(ReportContext);

    useEffect(() => {
        setLoading(true);
        setError(null);
        if (apiUrl) {
            axios.get<T>(apiUrl).then(response => {
                setError(null);
                setData(response.data);
            }).catch(err => {
                setError(err);
                setData(null);
            }).finally(() => {
                setLoading(false);
            });
        }
        else {
            setError(new Error('Given API URL is empty.'));
            setLoading(false);
        }
    }, [apiUrl, reportContext?.isUpdatedMemReport]);
    return { data, error, loading };
}
export default useFetch;